<template>
  <div class="block_center">
    <div class="productShowcase">
      <!-- 产品卡片轮播 -->
      <div class="productCarousel" ref="productCarousel">
        <el-carousel
          type="card"
          :autoplay="false"
          height="300px"
          @change="handleCarouselChange"
        >
          <el-carousel-item
            v-for="(product, index) in filteredProducts"
            @click="goToProductDetail(product)"
            :key="index"
          >
            <div class="productCard">
              <div
                class="cardImage"
                :style="{
                  backgroundImage: `url(${product.cardImg || product.introduceImg || ''})`,
                }"
              ></div>
              <div class="cardInfo">
                <div>
                  <h3 class="cardTitle">{{ language === 'en' && product.softNameEn ? product.softNameEn : product.softName }}</h3>
                  <h5 class="softCode">{{ product.softCode }}</h5>
                </div>
                <p class="cardContent" v-html="product.introduceTitle"></p>
                <div class="cardActions">
                  <button
                    class="downloadBtn"
                    @click="openDownloadDialog(product)"
                  >
                    {{ $t("Buy.DownloadNow") }}
                  </button>
                  <button class="moreBtn" @click.stop="scrollToLinkage">
                    {{ $t("Buy.learnMore") }}
                  </button>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div
      class="banner"
      ref="productIntroduction"
      :style="{ backgroundImage: `url(${currentProduct?.introduceImg})` }"
    >
      <div class="bannerContent">
        <div class="bannerLeft">
          <h1 class="bannerTitle">{{ language === 'en' && currentProduct?.softNameEn ? currentProduct?.softNameEn : currentProduct?.softName }}</h1>
          <h3 class="softCode">{{ currentProduct?.softCode }}</h3>
          <p class="bannerDesc" v-html="currentProduct?.introduceContent"></p>
        </div>
        <div class="bannerRight"></div>
      </div>
    </div>
    <div class="main_content">
      <!-- 左右联动区域 -->
      <div class="linkageContainer">
        <!-- 左侧菜单 -->
        <div class="leftMenu">
          <el-tooltip
            v-for="(item, index) in menuList"
            :key="index"
            :content="item.title"
            placement="right"
            effect="dark"
          >
            <div
              :class="['menuItem', { active: activeIndex === index }]"
              @click="scrollToSection(index)"
            >
              {{ item.title }}
            </div>
          </el-tooltip>
        </div>

        <!-- 右侧内容 -->
        <div class="rightContent" ref="rightContent" @scroll="handleScroll">
          <div
            v-for="(item, index) in menuList"
            :key="index"
            :ref="'section' + index"
            class="contentSection"
          >
            <div class="sectionHeader">
              <span class="dot"></span>
              <h3 class="sectionTitle">{{ item.title }}</h3>
            </div>
            <p class="sectionDesc" v-html="item.desc"></p>
          </div>
          <!-- 加载状态 -->
          <div class="loadingMore" v-if="loading">
            <i class="el-icon-loading"></i> 加载中...
          </div>
          <div class="noMoreData" v-if="!hasMore && menuList.length > 0">
            — 没有更多了 —
          </div>
        </div>
      </div>
    </div>
    <!-- 下载弹框 -->
    <el-dialog
      :visible.sync="downloadDialogVisible"
      :show-close="false"
      @open="onDialogOpen"
      @close="onDialogClose"
    >
      <div class="download-content">
        <div class="version-cards">
          <div
            v-for="(version, index) in groupedVersionList"
            :key="index"
            class="version-card"
            :class="{ active: selectedVersion === version.platformCode }"
            @click="selectVersion(version)"
          >
            <div
              class="version-icon"
              @click.stop="downloadCurrentVersion(version)"
            >
              <img
                :src="version.icon"
                :alt="version.name"
                class="version-img"
              />
              <!-- 下载悬浮层 -->
              <div class="download-overlay">
                <i class="el-icon-download"></i>
              </div>
            </div>
            <div class="version-name">{{ version.name }}</div>

            <!-- 国产信创有子选项下拉框 -->
            <el-select
              v-if="version.children && version.children.length > 1"
              v-model="selectedSubVersion"
              placeholder="请选择"
              size="small"
              class="sub-version-select"
              @click.native.stop
              @change="handleSubVersionChange"
            >
              <el-option
                v-for="child in version.children"
                :key="child.id"
                :label="child.platform"
                :value="child.platform"
              />
            </el-select>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSoftDownloadList,
  freeSoftList,
  freeSoftDetails,
} from "@/assets/API/pay";
import define from "@/utils/define";
// 平台图标映射
const PLATFORM_ICONS = {
  xc: require("@/assets/image/xinchuang-icon.png"),
  win: require("@/assets/image/windows-icon.png"),
};

// 平台名称映射
const PLATFORM_NAMES = {
  xc: "国产信创",
  win: "Windows X86",
};
export default {
  components: {},
  data() {
    return {
      define,
      productList: [],
      bgImg: "",
      activeIndex: 0,
      isScrolling: false,
      currentIndex: 0,
      menuList: [],
      language: this.$i18n.locale,
      // 分页相关
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      hasMore: true,
      // 下载列表
      downloadList: [],

      // 下载弹框相关
      downloadDialogVisible: false,
      selectedVersion: "", // 当前选中的版本 platformCode
      selectedSubVersion: "", // 国产信创子版本 id
      currentDownloadItem: null, // 当前选中的下载项

      // 原始版本列表
      rawVersionList: [],
    };
  },
  computed: {
    filteredProducts() {
      return this.productList;
    },
    currentProduct() {
      return this.filteredProducts[this.currentIndex] || null;
    },
    groupedVersionList() {
      const grouped = {};

      this.rawVersionList.forEach((item) => {
        const code = item.platformCode || "win";
        if (!grouped[code]) {
          grouped[code] = {
            platformCode: code,
            name: PLATFORM_NAMES[code] || code,
            icon: PLATFORM_ICONS[code] || "",
            children: [],
          };
        }
        grouped[code].children.push(item);
      });

      // 转为数组，按顺序排列（win在前，xc在后）
      const order = ["xc", "win"];
      return order.filter((code) => grouped[code]).map((code) => grouped[code]);
    },
  },
  mounted() {
    let query = {
      dataType: 1,
      sort: "desc",
      sidx: "",
      type: 1,
    };
    getSoftDownloadList(query).then((res) => {
      this.downloadList = res.data.list;
    });
    this.getfreeSoftList();
  },
  watch: {
    // 监听当前产品变化，重新获取详情列表
    currentProduct: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.resetAndLoadDetails();
        }
      },
      immediate: false,
    },
  },
  methods: {
    handleCarouselChange(currentIndex) {
      this.currentIndex = currentIndex;
    },
    // 通过路由 softId 定位到对应免费软件（首页banner跳转）
    locateSoftFromRoute() {
      const softId = this.$route.query.softId;
      if (!softId) return false;
      const index = this.productList.findIndex((item) => item.id === softId);
      if (index < 0) return false;
      this.currentIndex = index;
      this.$nextTick(() => {
        const carousel =
          this.$refs.carousel ||
          this.$children.find((child) => child.$options.name === "ElCarousel");
        if (carousel) {
          carousel.setActiveItem(index);
        }
        this.scrollToLinkage();
      });
      return true;
    },
    getfreeSoftList() {
      freeSoftList().then((res) => {
        if (res.data) {
          this.productList = res.data.map((item) => {
            return {
              ...item,
              introduceTitle:
                this.language == "zh"
                  ? item.introduceTitle
                  : item.introduceTitleEn,
              introduceContent:
                this.language == "zh"
                  ? item.introduceContent
                  : item.introduceContentEn,
              cardImg: this.define.APIURl + JSON.parse(item.cardImg)[0].url,
              relaDown: item.relaDown ? JSON.parse(item.relaDown) : [],
              bhImg: item.bhImg
                ? this.define.APIURl + JSON.parse(item.bhImg)[0].url
                : "",
              introduceImg: item.introduceImg
                ? this.define.APIURl + JSON.parse(item.introduceImg)[0].url
                : "",
            };
          });
          this.bgImg = this.productList[0].bhImg;
          // 获取第一个产品的详情列表
          if (this.productList.length > 0) {
            if (!this.locateSoftFromRoute()) {
              this.resetAndLoadDetails();
            }
          }
        }
      });
    },
    // 重置并加载详情列表
    resetAndLoadDetails() {
      this.menuList = [];
      this.currentPage = 1;
      this.hasMore = true;
      this.activeIndex = 0;
      this.loadSoftDetails();
    },
    // 加载软件详情列表
    loadSoftDetails() {
      if (
        !this.currentProduct ||
        !this.currentProduct.id ||
        this.loading ||
        !this.hasMore
      ) {
        return;
      }

      this.loading = true;
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        sort: "desc",
        sidx: "",
        title: "",
        softId: this.currentProduct.id,
      };

      freeSoftDetails(params)
        .then((res) => {
          if (res.data && res.data.records) {
            const list = res.data.records.map((item) => ({
              id: item.id,
              title: this.language === "zh" ? item.title : item.titleEn,
              desc: this.language === "zh" ? item.detail : item.detailEn,
              image: item.img
                ? this.define.APIURl + JSON.parse(item.img)[0].url
                : "",
            }));

            this.menuList = [...this.menuList, ...list];
            this.total = res.data.total || 0;

            // 判断是否还有更多数据
            if (
              this.menuList.length >= this.total ||
              list.length < this.pageSize
            ) {
              this.hasMore = false;
            }
          } else {
            this.hasMore = false;
          }
        })
        .catch((err) => {
          console.error("加载详情失败:", err);
          this.hasMore = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 加载更多
    loadMore() {
      if (this.hasMore && !this.loading) {
        this.currentPage++;
        this.loadSoftDetails();
      }
    },
    // 跳转到产品详情
    goToProductDetail(product) {
      this.$router.push({
        path: "/AllProducts",
        query: { name: product.name },
      });
    },
    // 点击左侧菜单，滚动到对应内容
    scrollToSection(index) {
      this.isScrolling = true;
      this.activeIndex = index;

      const section = this.$refs["section" + index];
      const container = this.$refs.rightContent;

      if (section && section[0] && container) {
        const offsetTop = section[0].offsetTop - container.offsetTop;
        container.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        setTimeout(() => {
          this.isScrolling = false;
        }, 500);
      }
    },
    scrollToLinkage() {
      const target = this.$refs.productIntroduction;
      if (!target) return;

      const fixedTopSelectors = [
        ".notice-image-wrap",
        ".notice-banner",
        ".summitek-header",
      ];
      const fixedTopBottom = fixedTopSelectors.reduce((bottom, selector) => {
        const fixedElement = document.querySelector(selector);
        if (!fixedElement) return bottom;

        const style = window.getComputedStyle(fixedElement);
        const rect = fixedElement.getBoundingClientRect();
        const visible = style.display !== "none"
          && style.visibility !== "hidden"
          && rect.height > 0;
        return visible ? Math.max(bottom, rect.bottom) : bottom;
      }, 0);
      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: Math.max(0, targetTop - fixedTopBottom),
        behavior: "smooth",
      });
    },

    // 右侧滚动时，更新左侧选中状态 + 上拉加载
    handleScroll() {
      const container = this.$refs.rightContent;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // 上拉加载：距离底部 100px 时触发
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadMore();
      }

      // 更新左侧菜单选中状态
      if (this.isScrolling) return;

      const containerTop = container.offsetTop;
      let currentIndex = 0;

      for (let i = 0; i < this.menuList.length; i++) {
        const section = this.$refs["section" + i];
        if (section && section[0]) {
          const sectionTop = section[0].offsetTop - containerTop;
          if (scrollTop >= sectionTop - 100) {
            currentIndex = i;
          }
        }
      }

      this.activeIndex = currentIndex;
    },

    openDownloadDialog(product) {
      this.rawVersionList = product.relaDown || [];
      console.log("版本列表:", this.rawVersionList);
      console.log("分组后:", this.groupedVersionList);

      this.selectedVersion = "";
      this.selectedSubVersion = "";
      this.currentDownloadItem = null;
      this.downloadDialogVisible = true;

      this.$nextTick(() => {
        if (this.groupedVersionList.length > 0) {
          const firstVersion = this.groupedVersionList[0];
          this.selectVersion(firstVersion);
        }
      });
    },

    // 选择版本
    selectVersion(version) {
      this.selectedVersion = version.platformCode;

      // 如果只有一个子项，直接选中
      if (version.children && version.children.length === 1) {
        this.selectedSubVersion = version.children[0].platform;
        this.currentDownloadItem = version.children[0];
      } else if (version.children && version.children.length > 1) {
        // 多个子项，默认选中第一个
        this.selectedSubVersion = version.children[0].platform;
        this.currentDownloadItem = version.children[0];
      } else {
        this.selectedSubVersion = "";
        this.currentDownloadItem = null;
      }
    },

    // 子版本变化
    handleSubVersionChange(id) {
      const version = this.groupedVersionList.find(
        (v) => v.platformCode === this.selectedVersion
      );
      if (version) {
        this.currentDownloadItem = version.children.find((c) => c.platform === id);
      }
    },

    // 下载当前版本
    downloadCurrentVersion(version) {
      let downloadItem = null;

      // 判断是否是当前选中的版本
      if (this.selectedVersion === version.platformCode) {
        // 如果已选中子版本，使用选中的下载项
        if (this.currentDownloadItem) {
          downloadItem = this.currentDownloadItem;
        } else if (this.selectedSubVersion) {
          // 根据选中的子版本id查找
          downloadItem = version.children.find(
            (c) => c.id === this.selectedSubVersion
          );
        }
      }

      // 如果没有选中，或者点击的不是当前选中的版本
      if (!downloadItem && version.children && version.children.length > 0) {
        // 先选中该版本
        this.selectVersion(version);
        // 使用第一个子项
        downloadItem = version.children[0];
      }

      if (!downloadItem || !downloadItem.downloadPath) {
        this.$message.warning("暂无下载链接");
        return;
      }

      // 执行下载
      const link = document.createElement("a");
      link.href = downloadItem.downloadPath;
      link.download = downloadItem.platform || "software";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 弹框打开时添加全局点击监听
    onDialogOpen() {
      this.$nextTick(() => {
        setTimeout(() => {
          document.addEventListener("click", this.handleGlobalClick);
        }, 200);
      });
    },

    // 弹框关闭时移除监听
    onDialogClose() {
      document.removeEventListener("click", this.handleGlobalClick);
    },

    // 全局点击事件 - 关闭弹框
    handleGlobalClick(e) {
      // 检查点击的元素是否在弹框内容区域内
      const dialogContent = document.querySelector(".download-content");
      const dialogHeader = document.querySelector(".el-dialog__header");

      if (
        dialogContent &&
        !dialogContent.contains(e.target) &&
        (!dialogHeader || !dialogHeader.contains(e.target))
      ) {
        this.downloadDialogVisible = false;
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleGlobalClick);
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  padding: 0;
  background: transparent;
  box-shadow: inherit;
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0px;
  }
}
.download-content {
  min-height: 350px;

  // 版本卡片区域 - 并排显示
  .version-cards {
    display: flex;
    gap: 60px;
    justify-content: center;
    align-items: center;

    .version-card {
      width: 310px;
      height: 410px;
      background: linear-gradient(
        122.84deg,
        rgba(247, 249, 255, 1) 0%,
        rgba(211, 218, 240, 1) 100%
      );
      border-radius: 16px;
      padding: 30px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;

      &:hover {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        border-color: #d0d0d0;
      }

      &.active {
        border-color: #2a82e4;
        box-shadow: 0 8px 20px rgba(42, 130, 228, 0.15);
      }

      .version-icon {
        width: 140px;
        height: 140px;
        margin: 0 auto 16px;
        position: relative;
        cursor: pointer;
        border-radius: 16px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: all 0.3s ease;
        }

        // 下载悬浮层 - 默认隐藏
        .download-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(42, 130, 228, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all 0.3s ease;
          border-radius: 16px;

          i {
            font-size: 48px;
            color: #fff;
          }
        }

        // 鼠标悬浮时显示下载图标
        &:hover {
          .version-img,
          img {
            transform: scale(0.9);
            opacity: 0.3;
          }

          .download-overlay {
            opacity: 1;
          }
        }
      }

      .version-name {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        margin-bottom: 15px;
      }

      .sub-version-select {
        width: 100%;

        ::v-deep .el-input__inner {
          border-radius: 8px;
          text-align: center;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.block_center {
  margin-top: 80px;
  background: url("../../../assets/image/free_soft_bg.png") no-repeat center top;
  background-size: 100% auto;
  .productShowcase {
    width: 1300px;
    margin: 0 auto;
  }
  .productCarousel {
    padding: 30px 0;
    .productCard {
      background: #fff;
      border-radius: 16px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      flex-direction: row-reverse;
      height: 100%;

      .cardImage {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
      }

      .cardInfo {
        padding: 20px;
        width: 50%;
        color: #333;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .cardTitle {
          font-size: 17px;
          font-weight: 600;
          margin: 0;
        }
        .softCode {
          font-size: 14px;
          margin: 0;
        }

        .cardName {
          font-size: 16px;
        }
        .cardContent {
          margin: 10px 0 20px;
          font-size: 13px;
          line-height: 22px;
          color: rgba(103, 103, 103, 1);
          display: -webkit-box;
          line-clamp: 4;
          -webkit-line-clamp: 4; /* 控制显示的行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .cardActions {
          display: flex;
          gap: 12px;

          .downloadBtn {
            width: 38%;
            padding: 6px 0;
            font-size: 14px;
            color: #fff;
            background: #2a82e4;
            border: none;
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              background: #1a6fc9;
            }
          }

          .moreBtn {
            width: 38%;
            padding: 6px 0;
            font-size: 14px;
            color: #666;
            background: #f5f5f7;
            border: none;
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              border-color: #2a82e4;
              color: #2a82e4;
            }
          }
        }
      }
    }
  }

  .banner {
    background-size:auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 621px;
    display: flex;
    align-items: center;
    position: relative;

    // // 添加渐变遮罩
    // &::before {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    //   background: linear-gradient(
    //     90deg,
    //     rgba(255, 255, 255, 0.95) 0%,
    //     rgba(255, 255, 255, 0.8) 50%,
    //     rgba(255, 255, 255, 0.03) 100%
    //   );
    // }

    .bannerContent {
      position: relative;
      z-index: 1;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 60px 0;

      .bannerLeft {
        flex: 1;
        max-width: 600px;

        .bannerTitle {
          font-size: 36px;
          font-weight: 600;
          color: #333;
          margin: 0 0 12px;
          line-height: 1.3;
        }

        .bannerSubtitle {
          font-size: 24px;
          font-weight: 500;
          color: #2a82e4;
          margin: 0 0 24px;
        }

        .bannerDesc {
          font-size: 14px;
          color: #666;
          line-height: 1.8;
          margin: 0;
          text-align: justify;
        }
      }

      .bannerRight {
        flex-shrink: 0;
        margin-left: 60px;
      }
    }
  }
  .main_content {
    background: #fff;
    // 左右联动区域
    .linkageContainer {
      display: flex;
      max-width: 1350px;
      margin: 0 auto;
      padding: 40px 0;
      min-height: 800px;

      // 左侧菜单
      .leftMenu {
        width: 200px;
        flex-shrink: 0;
        padding-right: 30px;
        position: sticky;
        top: 100px;
        height: fit-content;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .menuItem {
          width: 100%;
          padding: 8px 15px;
          font-size: 13px;
          color: #666;
          background-color: #f5f5f7;
          cursor: pointer;
          border-radius: 25px;
          margin-bottom: 8px;
          transition: all 0.3s;
          border: 1px solid transparent;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            color: #2a82e4;
            background: #f5f9ff;
          }

          &.active {
            color: #fff;
            background: #2a82e4;
            border-color: #2a82e4;
          }
        }
      }

      // 右侧内容
      .rightContent {
        flex: 1;
        max-height: 900px;
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
          width: 0px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-track {
          background: #f5f5f5;
        }

        .contentSection {
          margin-bottom: 60px;

          &:last-child {
            margin-bottom: 30px;
          }

          .sectionHeader {
            display: flex;
            align-items: center;
            margin-bottom: 15px;

            .dot {
              width: 8px;
              height: 8px;
              background: #2a82e4;
              border-radius: 50%;
              margin-right: 12px;
            }

            .sectionTitle {
              font-size: 20px;
              font-weight: 600;
              color: #333;
              margin: 0;
            }
          }

          .sectionDesc {
            font-size: 14px;
            color: #666;
            line-height: 1.8;
            margin-bottom: 20px;
            ::v-deep img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 20px auto;
            }
          }
        }
        // 加载中状态
        .loadingMore {
          text-align: center;
          padding: 20px 0;
          color: #999;
          font-size: 14px;

          i {
            margin-right: 8px;
          }
        }

        // 没有更多数据
        .noMoreData {
          text-align: center;
          padding: 20px 0;
          color: #ccc;
          font-size: 13px;
        }
      }
    }

    // 竞品对比
    .intro {
      text-align: center;
      display: flex;
      flex-direction: column;

      .introDes {
        font-size: 30px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 43.44px;
        color: #cccccc;
        text-align: center;
        vertical-align: top;
      }

      .introText {
        font-size: 40px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 57.92px;
        text-align: center;
        vertical-align: top;
      }
    }

    .mianCenter {
      width: 1350px;
      margin: 0 auto;
    }

    .uniqueBg {
      padding-bottom: 100px;

      .comparisonTable {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 40px;

        table {
          width: 100%;
          border-collapse: collapse;

          thead {
            tr {
              th {
                padding: 20px 30px;
                font-size: 23px;
                font-weight: 600;
                border-bottom: 1px solid #eee;

                &.featureCol {
                  text-align: left;
                  color: #333;
                  width: 30%;
                }

                &.otherCol {
                  text-align: center;
                  color: #666;
                  width: 35%;
                }

                &.summitCol {
                  text-align: center;
                  color: #2a82e4;
                  width: 35%;
                }
              }
            }
          }

          tbody {
            tr {
              transition: background-color 0.3s ease;

              &:hover {
                background-color: #f8faff;
              }

              td {
                padding: 18px 30px;
                font-size: 20px;
                font-weight: 600;
                border-bottom: 1px solid #f0f0f0;

                &.featureCol {
                  text-align: left;
                  color: #333;
                  padding-left: 40px;
                }

                &.otherCol {
                  text-align: center;
                  color: #666;
                }

                &.summitCol {
                  text-align: center;
                }

                .icon-cross {
                  color: #e74c3c;
                  font-size: 20px;
                  font-weight: bold;
                }

                .icon-check {
                  color: #27ae60;
                  font-size: 22px;
                  font-weight: bold;
                }

                .text-gray {
                  color: #888;
                }

                .text-highlight {
                  color: #27ae60;
                  font-weight: 600;
                }
              }

              &:last-child td {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
